var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "flex justify-between items-center gap-6 mb-6 mdmax:flex-wrap mdmax:gap-2"
  }, [_c('div', {
    staticClass: "flex-1 p-5 mdmax:p-4 bg-white rounded-md flex justify-between items-start"
  }, [_vm._m(0), _c('span', {
    staticClass: "flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-primary-100"
  }, [_c('Courier', {
    attrs: {
      "color": "neutral-700",
      "height": "18",
      "width": "18"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1 p-5 mdmax:p-4 bg-white rounded-md flex justify-between items-start"
  }, [_vm._m(1), _c('span', {
    staticClass: "flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-secondary-100"
  }, [_c('Truck', {
    attrs: {
      "color": "neutral-700",
      "height": "15",
      "width": "19"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1 p-5 mdmax:p-4 bg-white rounded-md flex justify-between items-start"
  }, [_vm._m(2), _c('span', {
    staticClass: "flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-primary-100"
  }, [_c('Order', {
    attrs: {
      "color": "neutral-700",
      "height": "18",
      "width": "18"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1 p-5 mdmax:p-4 bg-white rounded-md flex justify-between items-start"
  }, [_vm._m(3), _c('span', {
    staticClass: "flex w-9 h-9 mdmax:flex-shrink-0 justify-center items-center rounded-full bg-secondary-100"
  }, [_c('Delivered', {
    attrs: {
      "color": "neutral-700",
      "height": "20",
      "width": "19"
    }
  })], 1)])]), _vm.dataIsReady ? _c('div', {
    staticClass: "px-3 py-4 bg-white mb-6"
  }, [_vm._m(4), _c('TableComponent', {
    attrs: {
      "compact": "",
      "columns": _vm.columnsShipping,
      "list": _vm.pickupAssignment
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'order_delivery_schedule' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(entry[column.field])))]) : column.field === 'sender' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(_vm._s(entry.sender.name))]) : column.field === 'senderLocation' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(_vm._s(_vm.getAreaName(entry.sender.area_code) || '-'))]) : column.field === 'receiver' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(_vm._s(entry.receiver.name))]) : column.field === 'receiverLocation' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(_vm._s(_vm.getAreaName(entry.receiver.area_code) || '-') + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field]))])];
      }
    }], null, false, 2693341494)
  })], 1) : _vm._e(), _c('div', {
    staticClass: "px-3 py-4 bg-white"
  }, [_vm._m(5), _c('TableComponent', {
    attrs: {
      "compact": "",
      "columns": _vm.columnsArmada,
      "list": _vm.driverAssignment
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref2) {
        var entry = _ref2.entry,
            column = _ref2.column;
        return [column.field === 'from_area_code' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(_vm._s(_vm.getAreaName(entry.from_area_code) || '-'))]) : column.field === 'to_area_code' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(_vm._s(_vm.getAreaName(entry.to_area_code) || '-'))]) : _c('span', [_vm._v(_vm._s(entry[column.field]))])];
      }
    }])
  })], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {}, [_c('p', {
    staticClass: "text-neutral-500 mdmax:text-sm"
  }, [_vm._v("Total Agent")]), _c('p', {
    staticClass: "text-lg font-bold mb-6"
  }, [_vm._v("0")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {}, [_c('p', {
    staticClass: "text-neutral-500 mdmax:text-sm"
  }, [_vm._v("Total Armada")]), _c('p', {
    staticClass: "text-lg font-bold mb-6"
  }, [_vm._v("0")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {}, [_c('p', {
    staticClass: "text-neutral-500 mdmax:text-sm"
  }, [_vm._v("Request Pengiriman")]), _c('p', {
    staticClass: "text-lg font-bold mb-6"
  }, [_vm._v("0")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {}, [_c('p', {
    staticClass: "text-neutral-500 mdmax:text-sm"
  }, [_vm._v("Barang Terkirim")]), _c('p', {
    staticClass: "text-lg font-bold mb-6"
  }, [_vm._v("0")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex justify-between items-center mb-2"
  }, [_c('p', {
    staticClass: "text-lg font-bold"
  }, [_vm._v("Request Pengiriman")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex justify-between items-center mb-2"
  }, [_c('p', {
    staticClass: "text-lg font-bold"
  }, [_vm._v("Driver Assigment")])]);

}]

export { render, staticRenderFns }